import React from 'react';
import { TButtonOption, TRowOption, TSelectorRegularOption } from '../../../types/options';
import { VisualView } from '../../Image/VisualView';

type TSelectorRegularLeftIcon = {} & Pick<TButtonOption, 'iconName' | 'iconHierarchy' | 'iconVariant'> &
    Pick<TRowOption, 'avatar' | 'flagIcon'> &
    Pick<TSelectorRegularOption, 'isDisabled' | 'variant'>;

export const SelectorRegularLeftIcon = ({ iconName, iconVariant, iconHierarchy, avatar, flagIcon, variant, isDisabled }: TSelectorRegularLeftIcon) => {
    if (variant) {
        return false;
    }
    if (iconName) {
        return (
            <VisualView
                iconName={iconName}
                rightMargin
                iconHierarchy={iconHierarchy}
                iconVariant={iconVariant}
                size={'small'}
                isDisabled={isDisabled}
            />
        );
    }
    if (avatar) {
        return <VisualView rightMargin avatar={avatar} size={'small'} isDisabled={isDisabled} />;
    }
    if (flagIcon) {
        return <VisualView rightMargin flagIcon={flagIcon} size={'small'} isDisabled={isDisabled} />;
    }
    return false;
};
